S
<template>
  <div>
    <b-row>
      <b-col class="col-pw" cols="12">
        <b-form-group :class="vflowGetFeedbackClasses('password_')" class="password-group mandatory">
          <label for="password">
            <slot name="lblPassword">Passwort</slot>
          </label>
          <b-form-input
            @blur="vflowInputBlurred('password_');"
            @focus="vflowInputFocused('password_');"
            @input="$v.password_.$touch(); onPwInput();"
            @keyup.enter.prevent="onReturnKey();"
            name="password"
            id="password"
            ref="password_"
            required
            :type="passwordType"
            v-model="password_"
            autocomplete="new-password"
          ></b-form-input>
          <img :src="passwordIcon" alt="show" height="24" width="24" class="icon passwordIcon"
               @click="togglePasswordVisibility('password')"/>
          <b-form-invalid-feedback>
            <div v-if="(!$v.password_.passwordValidation)">
              <slot name="txtInvalidPasswordLiveFeedback">nicht die Regeln</slot>&nbsp;
              <slot name="txtAfterInput"></slot>
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-pw-repeat" cols="12">
        <b-form-group :class="vflowGetFeedbackClasses('repeat_')" class="password-group-2 mandatory">
          <label for="repeat">
            <slot name="lblPasswordRepeat">Passwort</slot>
          </label>
          <b-form-input
            @blur="vflowInputBlurred('repeat_');"
            @focus="vflowInputFocused('repeat_');"
            @input="$v.repeat_.$touch(); onRepeatInput();"
            @keyup.enter.prevent="onReturnKey();"
            name="repeat"
            id="repeat"
            ref="repeat_"
            required
            :type="passwordRepeatType"
            v-model="repeat_"
            autocomplete="new-password"
          ></b-form-input>
          <img :src="passwordRepeatIcon" alt="show" height="24" width="24" class="icon passwordIcon"
               @click="togglePasswordVisibility('repeat')"/>
          <b-form-invalid-feedback v-if="$v.repeat_.readyForValidation && !$v.repeat_.sameAsPassword">
            <slot name="txtInvalidSameAsLiveFeedback">Nicht gleich</slot>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import showHidePassword from '@/mixins/showHidePassword'
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import isValid from '@/mixins/validators/isValid'
import passwordValidator from '@/mixins/validators/passwordValidator'
import validationFlow from '@/mixins/validators/validationFlow'

export default {
  name: 'PasswordWithRepeat',
  mounted () {
    this.password_ = ''
    this.repeat_ = ''
    this.$v.$touch()
    this.invalid_ = this.$v.$invalid
  },
  methods: {},
  watch: {
    '$v.$invalid': function (v) {
      this.invalid_ = v
    }
  },
  mixins: [
    syncProperty('password', 'password_'),
    syncProperty('repeat', 'repeat_'),
    syncProperty('invalid', 'invalid_'),
    validationMixin,
    isValid,
    validationFlow,
    passwordValidator,
    showHidePassword()
  ],
  validations () {
    return {
      password_: {
        required,
        passwordValidation (v) {
          return this.validatePassword(v)
        }
      },
      repeat_: {
        required,
        readyForValidation (v) {
          return !this.$v.password_.$invalid
        },
        sameAsPassword: sameAs('password')
      }
    }
  },
  computed: {},
  props: {
    // name to identify is multiple are used in the same component
    name: {
      type: String,
      default: 'password'
    },
    onReturnKey: {
      type: Function,
      default: () => {
      }
    },
    onPwInput: {
      type: Function,
      default: () => {
      }
    },
    onRepeatInput: {
      type: Function,
      default: () => {
      }
    }
  }
}
</script>
